import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";

import SectionHeader from "./SectionHeader";

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(5),
  },
}));

type SectionProps = {
  id: string;
  children: React.ReactNode;
  title: React.ReactNode;
};

const Section: FC<SectionProps> = ({ children, id, title }) => {
  const classes = useStyles();

  return (
    <Box id={id} className={classes.section}>
      <SectionHeader title={title} />
      {children}
    </Box>
  );
};

export default Section;
